import React, { FC } from "react";

import { HeaderMenuProvider } from "../../contexts/header-menu";
import { HeaderMenuDesktop } from "./header-menu-desktop";
import { HeaderMenuMobile } from "./header-menu-mobile";
import { HeaderMenuLabels } from "./types";

export interface HeaderMenuProps {
  headerMenu: Queries.HeaderMenuDataFragment;
  labels: HeaderMenuLabels;
  pageContentfulId: string | null;
  internalPagePath: string | null;
}

export const HeaderMenu: FC<HeaderMenuProps> = ({
  labels,
  pageContentfulId,
  internalPagePath,
  headerMenu,
}) => {
  return (
    <HeaderMenuProvider
      headerMenu={headerMenu}
      pageContentfulId={pageContentfulId}
      internalPagePath={internalPagePath}
      labels={labels}
    >
      <HeaderMenuDesktop node_locale={headerMenu.node_locale} />
      <HeaderMenuMobile />
    </HeaderMenuProvider>
  );
};
